import 'jquery'
import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import '@/assets/styles/main.scss'
import VueParticles from 'vue-particles'
import { auth } from 'firebase/app'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import 'popper.js'
import Toasted from 'vue-toasted'
import filters from './filters'
import VueBreadcrumbs from 'vue-2-breadcrumbs'
import Meta from 'vue-meta'

import 'vue-easytable/libs/theme-default/index.css'
// Vue.config.devtools = true

Vue.use(VueBreadcrumbs)
Vue.use(filters)
Vue.use(Toasted)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Meta)
Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)

Vue.use(VueParticles)

const app = null

auth().onAuthStateChanged(() => {
  if (!app) {
    const app = new Vue({
      router,
      store,
      render: (h) => h(App)
    }).$mount('#app')
  }
})
